function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgAdd = function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 18 18",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    }
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 18.036,
    height: 18.036,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.886,8.149l7.671,0l0,1.737l-7.671,0l0,7.67l-1.738,0l0.001,-3.974l0,-3.696l-7.67,0l0,-1.737l7.67,0l-0.001,-7.669l1.738,-0.001c0,2.557 0,5.114 0,7.67Z",
    style: {
      fillRule: "nonzero"
    }
  }));
};
export default SvgAdd;